/**
 * Cache & service-worker reaper.
 *
 * Some previous CRA builds may have registered a service worker (e.g. an
 * older PWA experiment). Even after we removed the registration code, the
 * SW is still alive in users' browsers and continues to serve cached HTML
 * + assets — which means a fresh deploy is invisible to those visitors.
 *
 * On every boot we:
 *   1. Unregister every service worker the page can see.
 *   2. Drop every CacheStorage entry the SW created.
 *
 * Side-effects only — no rendering, no React state. Run once at app start.
 */

export const reapStaleCaches = async () => {
  if (typeof window === "undefined") return;

  // 1. Unregister any service worker registrations
  if ("serviceWorker" in navigator) {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister().catch(() => false)));
    } catch (e) { /* old browser or restricted context — ignore */ }
  }

  // 2. Drop every CacheStorage entry (filled by previous SW installs)
  if (typeof caches !== "undefined" && caches?.keys) {
    try {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k).catch(() => false)));
    } catch (e) { /* ignore */ }
  }
};
